export default __webpack_public_path__ + "static/media/fleshrot.191b5744.png";